import { gql } from '@apollo/client';
import { nextErrorFragmentWithErrorMessage } from 'next-common';
import {
  buildability,
  buildableConfiguration,
  vehicleConfigurationFields,
  vehicleShortConfigurationFields,
} from '../types';
import { vehicleConfigurationByConfigId } from 'common-graphql/queries';

export const queryVehicleDataFromPIM = gql`
query getVehicleDataFromPIM($input: VehicleDataQueryInput) {
  getVehicleDataFromPIM(input: $input) {     
    results {
      ${vehicleShortConfigurationFields}
    }
  }
}
`;

export const findVehicleById = gql`
  query vehicleById($id: ID!) {
    vehicleById(id: $id) {
      ${vehicleConfigurationFields}
    }
  }
`;

export const findVehicleByPimCode = gql`
  query vehicleByPimCode($pimCode: ID!) {
    vehicleByPimCode(pimCode: $pimCode) {
      ${vehicleShortConfigurationFields}
    }
  }
`;

export const dealerNameQuery = gql`
  query ($dealerId: String) {
    dealer(dealerId: $dealerId) {
      name
    }
  }
`;

export const getVehicleConfigurationByConfigIdQuery = gql`
  ${vehicleConfigurationByConfigId}
`;

export const checkVehicleConfigurationBuildabilityQuery = gql`
  query checkVehicleConfigurationBuildability($configId: String!) {
    checkVehicleConfigurationBuildability(configId: $configId) {
      ${buildability}
    }
  }
`;

export const getShareCodeBuildabilityQuery = gql`
  query getShareCodeBuildability($orderId: String!, $shareCode: String!) {
    getShareCodeBuildability(orderId: $orderId, shareCode: $shareCode) {
      ...buildability
      ...nextError
    }
  }
  ${buildableConfiguration}
  ${nextErrorFragmentWithErrorMessage}
`;

export const getHealingMBCodeQuery = gql`
  query getHealingMBCode($orderId: String!) {
    getHealingMBCode(orderId: $orderId) {
      healed
      addedOptions {
        code
        codeType
        id
        name
      }
      removedOptions {
        code
        codeType
        id
        name
      }
      totalPrice
    }
  }
`;

export const queryEquipmentsFromConfigurationByConfigId = gql`
  query getEquipmentsFromConfigurationByConfigId($configId: String!, $orderId: String!) {
    getEquipmentsFromConfigurationByConfigId(configId: $configId, orderId: $orderId) {
      name
      sku
    }
  }
`;

export const queryGetAuthorisedBrand = `
  query GetAuthorisedBrands($isAdmin: Boolean!, $dealerCode: String!) {
    getAuthorisedBrands(isAdmin: $isAdmin, dealerCode: $dealerCode) {
      brands
    }
  }
`;

export const getAccessoriesAndPCodesForSerialNoQuery = gql`
  query getAccessoriesAndPCodesForSerialNo($serialNo: String!) {
    getAccessoriesAndPCodesForSerialNo(serialNo: $serialNo) {
      trackTraceCode
      defaultAccessories {
        accessoryId
        accessoryDescription
        customerPriceExlVat
        vatCode
      }
      accessoriesAndTyres {
        accessories {
          pimSku
          priceExcludingVat
          price
          description
          vatCode
        }
        tires {
          id
          pimSku
          name
          price
          vatCode
          priceExcludingVat
        }
      }
      allPcodes {
        id
        articleCode
        vatCode
        articleCodeDesc
        localOptionCode
      }
      defaultPcodes {
        articleCode
        articleCodeDesc
        characteristicId
        costPriceExclVat
        customerPriceExclVat
        lastUpdated
        localOptionCode
        localOptionDescription
        localOptionCodeType
        trackTraceAdd
        trackTraceRemove
        validToDate
        validFromDate
        vatCode
        isDefaultPcode
        optionSource
      }
    }
  }
`;
